/**
 * Mijn-indeling helpers (Epic C-5 — Mijn indeling & navigatie, Story C-5.1)
 *
 * Losse `.ts`-utility (geen component-export) — react-refresh staat geen
 * niet-component-exports toe vanuit een `.tsx`-bestand, zelfde precedent als
 * `werkrooster/utils/*.ts` en `aanwezigheidVisuals.ts`.
 */

import type { MyAssignmentDagdeelEntry } from '@functieloonhuis/shared';

/** AD-13: indeelbaar dagdeel = kalenderstatus `werkt` ∨ `verlof_in_afwachting` (build_constraints "availability_definitions", bindend). */
export function isIndeelbaar(entry: MyAssignmentDagdeelEntry): boolean {
  return entry.status === 'werkt' || entry.status === 'verlof_in_afwachting';
}
